var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5b478ec1!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DownloadExternalStudySessionDocs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/lecturer/DownloadExternalStudySessionDocs.vue
// module id = 284
// module chunks = 1